<template>
    <div class="ml-3 text-gray-500 font-light">
        {{ $t('no-allocation-group-in-timeline-range', { allocationGroupType: injectedValues.type }) }}
    </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { allocationGroupKey } from './injectionKeys';

const injectedValues = inject(allocationGroupKey);
if (!injectedValues) {
    throw new Error('AllocationSelectionPanelEmpty must be used within a AllocationSelectionPanel component');
}
</script>
